export const LOGIN_FIRST_PAGE = '/login/phone';
export const SIGNUP_FIRST_PAGE = '/signup/name';
export const MEITAV_DASH_PERSONAL_AREA = 'https://customers.meitavdash.co.il';
